export const courseDuration = (durationInSeconds) => {
    let totalLength = '0 seconds';
    if (durationInSeconds < 60) {
        totalLength = durationInSeconds + ' seconds';
    } else if (durationInSeconds < 3600) {
        const minutes = Math.floor(durationInSeconds / 60);
        const seconds = Math.floor(durationInSeconds % 60);
        if (seconds !== 0)
            totalLength = minutes + ' minutes ' + seconds + ' seconds';
        else
            totalLength = minutes + ' minutes';
    } else {
        const hours = Math.floor(durationInSeconds / 3600);
        const minutes = Math.floor((durationInSeconds % 3600) / 60);
        if (minutes !== 0)
            totalLength = hours + ' hours ' + minutes + ' minutes';
        else
            totalLength = hours + ' hours';
    }
    return totalLength;
}